module.exports = __webpack_public_path__ + "img/dsci0114.c3618f5f.jpg";